import clsx from 'clsx/lite';
import { CSSProperties, type FC } from 'react';

interface ImageSrc {
  src: string;
  w?: number;
  h?: number;
}

interface Image {
  // Format -> array of image sizes
  sources: Record<string, Array<ImageSrc>>;
  img: ImageSrc;
}

interface PictureProps {
  image?: Image;
  alt: string;
  className?: string;
  imgClassName?: string;
  setDimensions?: boolean;
}

const Picture: FC<PictureProps> = ({
  image,
  alt,
  className,
  imgClassName,
  setDimensions = true,
}) => {
  if (!image) {
    return null;
  }

  let style: CSSProperties | undefined;

  if (setDimensions && image?.img?.h && image.img.w) {
    style = { height: `${image.img.h}px`, width: `${image.img.w}px` };
  }

  return (
    <picture className={clsx(className)}>
      {Object.entries(image.sources).map(([format, images]) => {
        if (typeof images?.map !== 'function') {
          return null;
        }

        const srcSet = images.map((i) => `${i.src}`).join(', ');
        return <source key={`${format}-${srcSet}`} type={`image/${format}`} srcSet={srcSet} />;
      })}
      <img
        src={image.img.src}
        alt={alt}
        className={clsx(imgClassName)}
        style={style}
        decoding="async"
      />
    </picture>
  );
};

export default Picture;
